export const DEFAULT_FORMAT_CHARS = {
  '9': /[0-9]/,
  a: /[A-Za-z]/,
  '*': /[A-Za-z0-9]/
};
export const parse = options => {
  let {
    mask,
    maskPlaceholder,
    format
  } = options;
  const defaultFormatChars = format || DEFAULT_FORMAT_CHARS;
  const permanents = [];

  if (typeof mask === 'string') {
    let isPermanent = false;
    let parsedMaskString = '';
    mask.split('').forEach(character => {
      if (!isPermanent && character === '\\') {
        isPermanent = true;
      } else {
        if (isPermanent || !defaultFormatChars[character]) {
          permanents.push(parsedMaskString.length);
        }

        parsedMaskString += character;
        isPermanent = false;
      }
    });
    mask = parsedMaskString.split('').map((character, index) => {
      if (permanents.indexOf(index) === -1) {
        return defaultFormatChars[character];
      }

      return character;
    });
  } else {
    mask.forEach((character, index) => {
      if (typeof character === 'string') {
        permanents.push(index);
      }
    });
  }

  if (maskPlaceholder) {
    let placeholder;

    if (maskPlaceholder.length === 1) {
      placeholder = mask.map((character, index) => {
        if (permanents.indexOf(index) !== -1) {
          return character;
        }

        return maskPlaceholder;
      });
    } else {
      placeholder = maskPlaceholder.split('');
    }

    permanents.forEach(position => {
      placeholder[position] = mask[position];
    });
    maskPlaceholder = placeholder.join('');
  }

  return {
    maskPlaceholder,
    mask,
    permanents
  };
};